export default function useSasRadicalCardHook() {
    const GetCardSprite = (character: string, isRadical: boolean, isSimplified: boolean) => {
        const part = isRadical ? 'R' : 'P';
        const unicode = character.codePointAt(0);
        const RadicalPartUrl: string = `parts/${isSimplified ? 'cn' : 'hk'}${unicode}_${character}/${part}${character}.png`;
        return RadicalPartUrl;
    };
    return { GetCardSprite };
}
